import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, locationHandle, isWx, locationHandlev2 } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import VueAudio from 'vue-audio';
// import 'vue-audio-player/dist/vueaudioplayer.css'

import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
export default {
  name: 'dspop',
  data() {
    return {
      fid: this.$route.query.fid,
      popLeftArr: [{
        name: '简介',
        id: 0
      }],
      popLeftIndex: 0,
      linkcontainerflag: false,
      iframeurl: '',
      infoList: [],
      videoitem: '',
      videoitemflag: false,
      daohangflag: true,
      viewer: null,
      audiodescflag: false,
      audiodesc: null,
      videoStyle: {
        objectFit: 'fill'
      },
      playbtn: true
    };
  },
  components: {
    VueAudio
  },
  watch: {
    '$attrs.detail'(val) {
      console.log('$attrs.detail', val);
    },
    '$attrs.detail.banner'(val) {
      if (val) {
        let that = this;
        this.$nextTick(() => {
          this.swiperEl = new Swiper(this.$refs.swipercontainer, {
            initialSlide: 0,
            slidesPerView: this.$attrs.isMobile ? 1 : 2.3,
            autoplay: true,
            speed: 500,
            spaceBetween: this.$attrs.isMobile ? 0 : 10,
            observeSlideChildren: true,
            observeParents: true,
            observer: true,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev"
            },
            touchEvents: false
          });
          // this.swiperEl.on('tap', function () {
          //     // 处理 Swiper 的点击事件
          //     that.initViewer()
          // });
        });
      }
    },
    '$attrs.detail.audio'(val) {
      if (val && val.length > 0) {
        let isHasaudio = this.popLeftArr.find(item => {
          return item.id === 3;
        });
        if (!isHasaudio) this.popLeftArr.push({
          name: '音频',
          id: 3
        });
      }
    },
    '$attrs.detail.video'(val) {
      if (val && val.length > 0) {
        let isHasvideo = this.popLeftArr.find(item => {
          return item.id === 2;
        });
        if (!isHasvideo) this.popLeftArr.push({
          name: '视频',
          id: 2
        });
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    // 统一换地址
    sethandleHttp(url) {
      return handleHttp(url);
    },
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      if (this.viewer) {
        this.viewer.destroy();
        this.viewer = null;
      }
      this.popLeftIndex = 0;
      this.popLeftArr = this.popLeftArr.filter(item => {
        return item.id === 0;
      });
      this.closevideoItem();
    },
    closevideoItem() {
      this.videoitemflag = false;
      this.videoitem = '';
      if (this.$attrs.isMobile && this.$attrs.direction && this.$refs.dsvideo) {
        this.$refs.dsvideo.paused;
        this.playbtn = true;
      }
    },
    reset() {
      this.popLeftIndex = 0;
      this.popLeftArr = this.popLeftArr.filter(item => {
        return item.id === 0;
      });
      this.closevideoItem();
    },
    // 弹窗左边点击事件
    popLeftHandle(id) {
      this.popLeftIndex = id;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    goLocation(url) {
      let newUrl = locationHandlev2.call(this, this.$attrs.detail, url);
      console.log(`newUrl`, newUrl);
    },
    // 跳转
    goLink(url) {
      // 若选择打开新窗口处理
      if (this.$attrs.detail.linkTarget !== undefined && this.$attrs.detail.linkTarget === '是') {
        window.open(url);
      } else {
        this.linkcontainerflag = true;
        this.iframeurl = url;
      }
    },
    // 视频切换
    videoItemHandle(item) {
      this.videoitemflag = true;
      this.videoitem = this.popLeftIndex === 2 ? item : item.itemformdata;
      if (this.$attrs.isMobile && this.$attrs.direction) {
        let width = document.body.clientWidth;
        let height = document.body.clientHeight;
        this.videoStyle.width = `${height}px`;
        this.videoStyle.height = `${width}px`;
        this.videoStyle.transform = `rotate(90deg) translate(${(height - width) / 2}px, ${(height - width) / 2}px)`;
      }
    },
    videoplay() {
      this.playbtn = false;
      this.$refs.dsvideo.play();
    },
    initViewer() {
      if (this.viewer) return;
      this.$nextTick(() => {
        let that = this;
        this.viewer = new Viewer(document.querySelector('.swiper-wrapper'), {
          navbar: false,
          // 显示导航栏
          toolbar: {
            zoomIn: 1,
            zoomOut: 1,
            oneToOne: 1,
            reset: 0,
            prev: 0,
            play: 0,
            next: 0,
            rotateLeft: 1,
            rotateRight: 1,
            flipHorizontal: 1,
            flipVertical: 1
          },
          // 显示工具栏
          title: false,
          transition: false,
          viewed() {
            if (that.$attrs.imgrotate !== undefined && that.$attrs.imgrotate) {
              that.viewer.rotateTo(90);
              document.querySelector('.viewer-container').classList.add(`fid${that.$route.query.fid}`);
            }
          }
        });
      });
    },
    getAddress(val) {
      let data = val[0];
      let addressArr = ['country', 'province', 'city', 'district', 'street'];
      let str = '';
      addressArr.forEach(elem => {
        if (data[elem] && data[elem] !== undefined && data[elem] !== '') str += data[elem];
      });
      if (str === '' && data.address !== undefined) str = data.address;
      return str;
    },
    playaudiodesc() {
      this.audiodesc = document.querySelector('#audiodesc');
      if (!this.audiodesc) return false;
      if (this.audiodescflag) {
        this.audiodesc.pause();
        this.audiodescflag = false;
      } else {
        this.audiodesc.play();
        this.audiodescflag = true;
      }
    }
  }
};